import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/payment_return_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
const PaymentReturnSchema = withDefaults({
  type: 'payment-return',
  fields: [
    { kind: 'attribute', name: 'amount' },
    { kind: 'attribute', name: 'checkDate' },
    { kind: 'attribute', name: 'checkNumber' },
    { kind: 'attribute', name: 'currencyType' },
    { kind: 'attribute', name: 'importedDate' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'isActive' },
    { kind: 'attribute', name: 'outcome' },
    { kind: 'attribute', name: 'paymentMethod' },
    { kind: 'attribute', name: 'reason' },
    { kind: 'attribute', name: 'state' },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
  ],
});

export default PaymentReturnSchema;
